module.exports = __webpack_public_path__ + "img/wg.e443c547.png";